import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=0e4148a9&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=0e4148a9&prod&scoped=true&lang=scss&"
import style1 from "./_id.vue?vue&type=style&index=1&id=0e4148a9&prod&lang=scss&"
import style2 from "./_id.vue?vue&type=style&index=2&id=0e4148a9&prod&lang=css&"
import style3 from "./_id.vue?vue&type=style&index=3&id=0e4148a9&prod&lang=scss&scoped=true&"
import style4 from "./_id.vue?vue&type=style&index=4&id=0e4148a9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4148a9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavBarHorizontal: require('C:/Users/Administrator/Desktop/meccle/nuxt-pc/components/NavBar/horizontal.vue').default,Rest: require('C:/Users/Administrator/Desktop/meccle/nuxt-pc/components/restCart/rest.vue').default,Discounts: require('C:/Users/Administrator/Desktop/meccle/nuxt-pc/components/discountsPopUp/discounts.vue').default})
